export const main_routes = [
    {
        // path: '/:lang([a-z]{2})',
        path: '/',
        name: 'index',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "" } },
        // props: { data: { page: "Agenda", data: {depId: 1} } },
        meta: { requireAuth: true },
        // children: []
    },
    {
        path: '/login',
        name: "login",
        component: () => import('@/layouts/Login'),
        props: { data: {} },
        meta: { requireNone: true, guestOnly: true },
    },
    {
        path: '/roles',
        name: 'roles',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "system_modules/role/Role" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/users',
        name: 'users',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "system_modules/user/Users" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/file_browser',
        name: 'file_browser',
        component: () => import('@/components/FileBrowser'),
        meta: { requireAuth: true, requireAdmin: false },
    },

    // {
    //     path: '/dashboard',
    //     name: 'dashboard',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "system_modules/dashboard/Dashboard" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    // {
    //     path: '/dashboard2',
    //     name: 'dashboard2',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "system_modules/dashboard/Dashboard2" } },
    //     meta: { requireAuth: false, requireAdmin: false },
    // },

    {
        path: '/terms',
        name: 'terms',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "system_modules/settings/Language" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/languages',
        name: 'languages',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "system_modules/settings/LanguageMulti" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/system',
        name: 'settings',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "system_modules/settings/System" } },
        meta: { requireAuth: true, requireAdmin: false },
    },

    {
        path: '/profile',
        name: 'profile',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "system_modules/profile/Profile" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "system_modules/settings/About" } },
        meta: { requireNone: true, guestOnly: true },
    },

    {
        path: '/pdf/:view/:id/:url',
        name: 'pdf_viewer_letter',
        component: () => import('@/layouts/Empty'),
        props: { data: { page: `views/PDFViewer` } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    // {
    //     path: '/pdf/:view/:url',
    //     name: 'pdf_viewer',
    //     component: () => import('@/layouts/Empty'),
    //     props: { data: { page: `views/PDFViewer` } },
    //     // meta: { requireAuth: true, requireAdmin: true },
    // },

    {
        path: '/notfoundf',
        name: 'notfound_full',
        component: () => import('@/layouts/404'),
        props: { data: { page: "system_modules/NotFound" } },
        meta: { requireAuth: false },
    },
    {
        path: '/notfound',
        name: 'notfound',
        component: () => import('@/layouts/404'),
        props: { data: { page: "system_modules/NotFound" } },
        meta: { requireAuth: false },
    },
    {
        path: '/notperm',
        name: 'notperm',
        component: () => import('@/layouts/Empty'),
        props: { data: { page: "system_modules/NotPermission" } },
        meta: { requireAuth: false },
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('@/layouts/404'),
        props: { data: { page: "system_modules/NotFound" } },
        meta: { requireAuth: false },
    },
    {
        path: '/:catchAll(.*)',
        name: '4041',
        component: () => import('@/layouts/404'),
        props: { data: { page: "system_modules/NotFound" } },
        meta: { requireAuth: false },
    },
]
